// Obsah knihy – převzato z finálního PDF „40 principů lepšího muže".
// Ukázky (excerpt) jsou doslovný text z PDF, ne přepis.

export const PARTS = [
  {
    numeral: "I",
    title: "Nejdřív vybuduj sebe",
    range: "Principy 1–8",
    description:
      "Základ, na kterém stojí všechno ostatní. Autenticita, odpovědnost za vlastní život, sebevědomí a vztah k sobě samému.",
    principles: [
      "Buď autentický",
      "Přijmi odpovědnost za svůj život",
      "Sebevědomí se buduje",
      "Nauč se být sám",
      "Nepotřebuj souhlas všech",
      "Jednej navzdory strachu",
      "Nehledej ženu. Vytvoř život, jehož chce být součástí.",
      "Ovládej své emoce, nepotlačuj je",
    ],
  },
  {
    numeral: "II",
    title: "Vytvoř si život, který stojí za to žít",
    range: "Principy 9–16",
    description:
      "Směr, disciplína, tělo, učení a lidé kolem tebe. Život, který dává smysl i bez vztahu.",
    principles: [
      "Měj svůj směr",
      "Tvůj život musí být větší než tvůj vztah",
      "Buduj pestrý život",
      "Pečuj o své tělo",
      "Neustále se něco uč",
      "Vytvářej, nejen konzumuj",
      "Tvoje okolí tě mění",
      "Pěstuj skutečná přátelství",
    ],
  },
  {
    numeral: "III",
    title: "Ženy, přitažlivost a seznamování",
    range: "Principy 17–24",
    description:
      "Jak funguje přitažlivost, jak projevit zájem bez nátlaku a jak se vypořádat s odmítnutím bez ztráty sebeúcty.",
    principles: [
      "Přitažlivost není rozhodnutí",
      "Přitažlivost nemusíš vždy proměnit v akci",
      "Zájem projev, nevynucuj",
      "Odmítnutí není rozsudek nad tvojí hodnotou",
      "Nesnaž se přesvědčit ženu, která tě nechce",
      "Neidealizuj krásu",
      "Nevybírej jen ženu. Všímej si, jaký jsi vedle ní muž.",
      "Flirt je hra, ne zkouška vlastní hodnoty",
    ],
  },
  {
    numeral: "IV",
    title: "Muž ve vztahu",
    range: "Principy 25–32",
    description:
      "Komunikace, hranice, konflikty i obyčejné dny. Jak zůstat ve vztahu sám sebou — a nepřestat být partnerem.",
    principles: [
      "Poslouchej, než začneš opravovat",
      "Říkej, co skutečně chceš",
      "Nauč se říkat ne",
      "Nepleť si lásku se závislostí",
      "Nenech konflikt rozhodovat za tebe",
      "Chval konkrétně a upřímně",
      "Neber partnerku jako samozřejmost",
      "Dopřej vztahu prostor",
    ],
  },
  {
    numeral: "V",
    title: "Intimita, charakter a zralost",
    range: "Principy 33–40",
    description:
      "Intimita, slovo, které platí, a charakter. Závěrečná otázka celé knihy: jakým mužem se vlastně chceš stát?",
    principles: [
      "Dobrý sex začíná mimo ložnici",
      "V intimitě buď přítomný, ne výkonný",
      "Touhu ovládej, nepotlačuj",
      "Dodržuj své slovo",
      "Uměj odejít",
      "Selhání proměň ve zkušenost",
      "Nikdy nejsi hotový",
      "Staň se mužem, kterého si sám vážíš",
    ],
  },
];

const p = (text) => ({ type: "p", text });
const h = (text) => ({ type: "h", text });

export const PREVIEWS = [
  {
    number: "03",
    title: "Sebevědomí se buduje",
    teaser:
      "Sebevědomí nevzniká čekáním na správný pocit. Pořadí je přesně opačné — nejdřív jednání, teprve potom důvěra v sebe.",
    excerpt: [
      p(
        "Většina lidí by chtěla získat sebevědomí ještě předtím, než začne dělat věci, které sebevědomí vytvářejí."
      ),
      p("„Až si budu víc věřit, oslovím ji.“"),
      p("„Až budu sebevědomější, změním práci.“"),
      p("„Až se přestanu bát, pojedu sám do zahraničí.“"),
      p(
        "Člověk čeká na vnitřní stav, který má podle něj umožnit akci. Jenže velmi často je pořadí přesně opačné."
      ),
      p("Nejdřív přichází jednání. Teprve potom důvěra v sebe."),
      h("Sebevědomí není jistota výsledku"),
      p(
        "Sebevědomý muž není člověk, který věří, že uspěje ve všem. To by nebylo sebevědomí, ale nereálný obraz sebe sama."
      ),
      p(
        "Můžeš přijít na pracovní pohovor a nevědět, jestli tě přijmou. Můžeš oslovit ženu a nemít tušení, zda bude mít zájem. Můžeš rozjet projekt a vůbec nevědět, zda vyjde."
      ),
      p("Pevnější forma sebevědomí zní jinak:"),
      p("„Nevím, jak to dopadne. Ale věřím, že se dokážu vypořádat s tím, co přijde.“"),
      p(
        "Toto sebevědomí je odolnější, protože nestojí na přesvědčení, že vždy vyhraješ. Stojí na zkušenosti, že přežiješ i prohru."
      ),
    ],
  },
  {
    number: "07",
    title: "Nehledej ženu. Vytvoř život, jehož chce být součástí.",
    teaser:
      "Otázka není, jak získat ženu. Otázka, která má přijít dřív, zní: do jakého života ji vlastně zveš?",
    excerpt: [
      p("Muž může strávit roky otázkou:"),
      p("Jak získat ženu?"),
      p("Existuje ale otázka, která by měla přijít dřív:"),
      p("Do jakého života ji vlastně zveš?"),
      p("Představ si dvě verze stejného muže."),
      p(
        "První tráví velkou část volného času hledáním vztahu. Seznamovací aplikace, zprávy, schůzky, sledování reakcí. Když někoho pozná, rychle přizpůsobí svůj program. Jeho víkendy se začnou řídit podle ní. Zájmy ustoupí. Přátele vídá méně. Velká část energie jde do otázky, zda vztah pokračuje správným směrem."
      ),
      p("Druhá verze stejného muže chce vztah také. Ale mezitím žije."),
      p(
        "Má práci nebo projekt, ke kterému má vztah. Sportuje. Má přátele. Něco se učí. Občas někam jede. Má plány, které existovaly před konkrétní ženou a budou existovat i bez ní."
      ),
      p("Když potká někoho zajímavého, udělá pro ni ve svém životě prostor."),
      p("Nevymaže kvůli ní celý jeho obsah."),
      p("To je podstata tohoto principu."),
      h("Nejde o trik na ženy"),
      p("Tento princip by bylo velmi snadné zkazit."),
      p("„Vybuduj si zajímavý život, protože ženy pak přijdou samy.“"),
      p(
        "To by byla pouze sofistikovanější forma stejného problému. Pořád bys všechno dělal kvůli ženskému uznání."
      ),
    ],
  },
  {
    number: "10",
    title: "Tvůj život musí být větší než tvůj vztah",
    teaser:
      "Vztah je část života, ne jeho náhrada. Problém nezačíná, když zmizí volný čas — ale když postupně mizí kus člověka.",
    excerpt: [
      p("Na začátku vztahu je snadné chtít být spolu pořád."),
      p(
        "Dlouhé večery. Zprávy během dne. Společné víkendy. Plány. Sex. Výlet. Další večer. Další víkend."
      ),
      p(
        "Člověk, který ještě před několika měsíci bez problémů žil svůj vlastní život, najednou přestane mít čas na polovinu věcí, které předtím dělal."
      ),
      p("Částečně je to přirozené."),
      p(
        "Problém začíná tehdy, když nezmizí jen volný čas, ale postupně i kus člověka."
      ),
      h("Vztah je část života, ne jeho náhrada"),
      p(
        "Princip 7 mluvil o tom, abys nevytvářel život pouze jako čekárnu na ženu. Tento princip jde o krok dál."
      ),
      p("Co se stane, když ji skutečně potkáš?"),
      p("Dokážeš si svůj život zachovat?"),
      p(
        "Někteří muži jsou samostatní jen do prvního vážného vztahu. Pak se jejich svět začne pomalu zužovat. Méně sportu. Méně kamarádů. Méně vlastních projektů. Méně času o samotě."
      ),
      p("Ne vždy proto, že by to partnerka požadovala."),
      p("Často to udělají sami."),
      p(
        "Vztah je příjemný, pohodlný a okamžitě odměňující. Je jednodušší strávit večer společně než jít trénovat. Jednodušší pustit si seriál než pokračovat na projektu, jehož výsledek přijde za rok."
      ),
      p("Postupně může vzniknout život, který je příjemný, ale stále menší."),
    ],
  },
  {
    number: "22",
    title: "Neidealizuj krásu",
    teaser:
      "Krása má sílu — a nemá smysl to popírat. Problém začíná, když jí v hlavě připíšeš vlastnosti, o kterých nic nevíš.",
    excerpt: [
      p("Vešla do místnosti a okamžitě jsi ji zaznamenal."),
      p("Nemusela nic říct."),
      p("Je prostě nádherná."),
      p(
        "O několik minut později o ní nevíš téměř nic – a přesto už může tvoje hlava začít pracovat. Představuješ si, jaká asi je. Připisuješ jí vlastnosti. Její sebevědomí vypadá jako inteligence. Její elegance jako charakter. Její úsměv jako laskavost."
      ),
      p("Přitom zatím víš jediné:"),
      p("Velmi se ti líbí její vzhled."),
      p("To není málo. Ale samo o sobě to nestačí."),
      h("Krása má sílu – proto ji není třeba popírat"),
      p("Nemá smysl mužům tvrdit, že vzhled není důležitý."),
      p("Je."),
      p(
        "Pokud hledáš romantický a sexuální vztah, fyzická přitažlivost je legitimní součást výběru. Můžeš chtít ženu, která se ti líbí. Nemusíš se za to omlouvat."
      ),
      p("Problém nezačíná u přitažlivosti."),
      p(
        "Začíná tehdy, když krása dostane v tvé hlavě pravomoc rozhodovat o věcech, o kterých nic nevypovídá."
      ),
      h("Když krása zkresluje úsudek"),
      p(
        "Atraktivní člověk může v našich očích získat vlastnosti, které jsme ještě neměli možnost ověřit. Najednou více toleruješ chování, které by ti u někoho jiného vadilo."
      ),
      p("Přijde pozdě. Nevadí. Téměř se na nic neptá. Je nervózní. Mluví nepříjemně o lidech. Asi měla těžký den. Třikrát zruší schůzku."),
    ],
  },
  {
    number: "29",
    title: "Nenech konflikt rozhodovat za tebe",
    teaser:
      "Cílem není nehádat se. Cílem je naučit se nesouhlasit způsobem, který neničí vztah.",
    excerpt: [
      p("Je půl jedenácté večer."),
      p("Oba jste unavení."),
      p("Partnerka řekne něco, co vnímáš jako výčitku."),
      p("Ty odpovíš ostřeji."),
      p("Ona přitvrdí."),
      p("Za pět minut už neřešíte původní problém."),
      p(
        "Řešíte tón. Starou hádku. Její matku. Tvého kamaráda. Dovolenou před dvěma lety a větu, kterou si jeden z vás pamatuje úplně jinak."
      ),
      p(
        "V jednu chvíli přesně víš, co bys neměl říct. A přesto to řekneš. Protože už nechceš problém vyřešit."
      ),
      p("Chceš vyhrát."),
      h("Konflikt není porucha vztahu"),
      p("Dva lidé, kteří spolu skutečně žijí, budou někdy chtít rozdílné věci."),
      p(
        "Budou unavení v jinou dobu. Budou mít jiný názor na peníze, domácnost, sex, rodinu, dovolenou, děti nebo volný čas."
      ),
      p("Představa dobrého vztahu bez konfliktu je proto nebezpečná."),
      p(
        "Může vést k tomu, že jeden nebo oba lidé raději mlčí, jen aby udrželi zdání harmonie. Jenže potlačený konflikt nezmizí."
      ),
      p("Často pouze změní podobu."),
      p(
        "Objeví se jako chlad, ironie, ztráta sexuálního zájmu, podrážděnost nebo stále stejné malé hádky."
      ),
      p("Cílem není nehádát se."),
      p("Cílem je naučit se nesouhlasit způsobem, který neničí vztah."),
    ],
  },
  {
    number: "40",
    title: "Staň se mužem, kterého si sám vážíš",
    teaser:
      "Všechny předchozí principy míří k jediné otázce, před kterou se neschováš: Vážím si člověka, kterým jsem se stal?",
    excerpt: [
      p(
        "Představ si, že se ti podaří získat všechno, o čem sis kdysi myslel, že tě definitivně udělá hodnotným."
      ),
      p("Máš peníze."),
      p("Dobrou práci."),
      p("Tělo, které se ti líbí."),
      p("Ženy o tebe mají zájem. Možná máš krásnou partnerku."),
      p("Dům."),
      p("Auto."),
      p("Lidé tě respektují."),
      p("Na sociálních sítích může tvůj život působit téměř bezchybně."),
      p("A přesto existuje otázka, před kterou tě žádná z těchto věcí nedokáže ochránit:"),
      p("Vážím si člověka, kterým jsem se stal?"),
      p(
        "Tohle je poslední princip celé knihy, protože všechny předchozí k němu nějakým způsobem mířily."
      ),
      p("Ne k dokonalosti."),
      p("K sebeúctě."),
      h("Vnější úspěch není podvod"),
      p("Bylo by snadné teď říct:"),
      p("„Na penězích nezáleží.“ „Na vzhledu nezáleží.“ „Na úspěchu nezáleží.“"),
      p("Jenže záleží."),
      p("Peníze mohou přinést svobodu, bezpečí a možnosti."),
      p("Silné tělo může přinést energii i radost."),
      p("Úspěch v práci může být hluboce uspokojující."),
      p("Sex, přitažlivost a ženy jsou legitimní součást života."),
      p("Není nutné všechno vnější znehodnotit, abychom mohli mluvit o charakteru."),
    ],
  },
];

export const FAQ = [
  {
    q: "Jak e-book dostanu?",
    a: "Po zaplacení přes SimpleShop ti přijde e-mail s odkazem ke stažení PDF. E-book si můžeš stáhnout ihned — na mobilu, tabletu i počítači.",
  },
  {
    q: "Je e-book i pro muže, kteří jsou ve vztahu?",
    a: "Ano. Kniha není jen o seznamování. Část IV se věnuje vztahu samotnému — komunikaci, hranicím a konfliktům — a část V intimitě, charakteru a zralosti. Principy dávají smysl i pro muže, kteří žijí v dlouholetém vztahu.",
  },
  {
    q: "Musím e-book číst postupně od začátku do konce?",
    a: "Nemusíš. Každý ze 40 principů stojí sám za sebou a můžeš začít tématem, které právě řešíš. Přesto spolu jednotlivé principy souvisejí — jako celek tvoří ucelený rámec, ke kterému se můžeš vracet.",
  },
  {
    q: "Je to tištěná kniha?",
    a: "Ne. Jde o digitální e-book ve formátu PDF. Žádná zásilka nečeká na poště — PDF je tvoje ihned po zaplacení.",
  },
  {
    q: "Jak probíhá platba?",
    a: "Platbu zajišťuje česká služba SimpleShop. Po kliknutí na tlačítko tě přesměrujeme do zabezpečeného objednávkového formuláře, kde zaplatíš online. Doklad o koupi ti vystaví přímo SimpleShop.",
  },
  {
    q: "Kdy e-book dostanu?",
    a: "Ihned po připsání platby. Odkaz ke stažení ti přijde e-mailem automaticky — bez čekání.",
  },
  {
    q: "V jakém formátu e-book dostanu?",
    a: "Ve formátu PDF. Pohodlně ho přečteš na telefonu, tabletu, počítači i většině čteček elektronických knih.",
  },
  {
    q: "Mohu e-book vrátit?",
    a: "E-book je digitální obsah, který je zpřístupněn ihned po zaplacení. V objednávce proto udělíš výslovný souhlas s okamžitým zpřístupněním a potvrdíš, že bereš na vědomí, že tím za podmínek § 1837 písm. l) občanského zákoníku zaniká právo odstoupit od smlouvy ve 14denní lhůtě. Podrobnosti najdeš v obchodních podmínkách.",
  },
];
